import { Link } from "react-router-dom";
import { profileIntro } from "@/mocks/profile";
import { siteIntro } from "@/mocks/site";

export default function AboutIntro() {
  return (
    <section className="px-4 md:px-8 py-12 md:py-16 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div className="relative rounded-lg overflow-hidden aspect-[4/3] bg-background-200 order-2 lg:order-1">
          <img
            src="https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20serene%20backstage%20studio%20with%20a%20warm%20desk%20lamp%2C%20sheet%20music%20and%20a%20film%20script%2C%20deep%20navy%20shadows%20with%20amber%20light%2C%20minimal%20elegant%20composition%2C%20high%20detail%2C%20quiet%20creative%20mood&width=1200&height=900&seq=about-01&orientation=landscape"
            alt="森泽佳奈创作日常"
            title="森泽佳奈 - 光影与旋律之间的创作日常"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="order-1 lg:order-2">
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase text-accent-600 mb-3">
            <span className="w-6 h-px bg-accent-500"></span>
            About
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            关于森泽佳奈
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            {profileIntro.bio[0]}
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            {siteIntro.description}
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
            {siteIntro.highlights.map((h) => (
              <div key={h.label} className="p-3 rounded-lg bg-background-100 border border-background-200 text-center">
                <div className="font-heading text-xl md:text-2xl font-bold text-primary-600">{h.value}</div>
                <div className="text-xs text-foreground-500 mt-1">{h.label}</div>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/profile"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-user-3-line"></i>
              查看个人资料
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}